// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"10":"b6b13865","397":"2ddf3fe9","580":"f756bb42","593":"7a39967d"}[chunkId] + ".css";
};